import React from 'react';
import { Text } from '../../atoms/Text';
import { List } from '../../atoms/List';
import { ListItem } from '../../atoms/ListItem';
import { Link } from '../../atoms/Link';
import { hostBase } from '../../helpers/hostBase';
import './FooterSection.css';

export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

export interface FooterSectionProps {
  /**
   * Section title
   */
  title: string;
  /**
   * Links to display in this section
   */
  links: FooterLink[];
  /**
   * Domain to prefix for non-external links. The empty string means
   * same-origin: links render path-relative and stay on the current host
   * (see helpers/hostBase).
   */
  wwwDomain?: string;
  /**
   * Custom CSS classes
   */
  className?: string;
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  title,
  links,
  wwwDomain = 'www.heartinternet.uk',
  className = '',
}) => {
  const baseClass = 'hi-ui hi-ui-footer-section';
  const allClasses = `${baseClass} ${className}`.trim();
  const base = hostBase(wwwDomain);

  return (
    <div className={allClasses}>
      {/* `as="h2"` (level) is decoupled from `variant="heading-5"` (size): the
          footer is a top-level contentinfo region, so its section titles are h2s
          — without the explicit level they'd render <h5> and skip from a page's
          h2/h3 straight to h5 (axe `heading-order`). Size is unchanged. */}
      <Text as="h2" variant="heading-5" className="hi-ui-footer-section__title">
        {title}
      </Text>
      <List listStyle="none" className="hi-ui-footer-section__list">
        {links.map((link) => (
          <ListItem key={link.href}>
            <Link
              href={link.external ? link.href : `${base}${link.href}`}
              external={link.external}
              noUnderline
            >
              {link.label}
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );
};
